import {makeAutoObservable} from 'mobx'
import {
  ColumnColor,
  DataObjectId,
  getColumnColorNumber,
  getColumnColors
} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {createUseStore} from '@containers/hooks'
import {Column} from '@extensions/column'
import {globals} from '@extensions/globals-base'

export const getAllColors = () => {
  const colors = getColumnColors(globals.theme)
  return Object.keys(colors).map(
    key => [Number(key), colors[Number(key)]] as const
  )
}

interface State {
  selected: ColumnColor
  columnId: DataObjectId
}

export class ColorPickerStore {
  state: State = {
    selected: null,
    columnId: null
  }

  constructor(columnId: DataObjectId) {
    makeAutoObservable(this)
    this.state.columnId = columnId
    const column = Column.getById(columnId)
    this.state.selected = getColumnColorNumber(column)
  }

  isAllowedToEditColor(): boolean {
    const column = Column.getById(this.state.columnId)
    return PermissionsChecker.checkRename(column)
  }

  setSelected(selected: ColumnColor): void {
    this.state.selected = selected
    const column = Column.getById(this.state.columnId)
    if (column) {
      column.data.columnColor = selected
      column.commit()
    }
  }
}

export const [Context, useStore] = createUseStore(ColorPickerStore)
